import { render, staticRenderFns } from "./modalAddRoom.vue?vue&type=template&id=610bd146&scoped=true&"
import script from "./modalAddRoom.vue?vue&type=script&lang=js&"
export * from "./modalAddRoom.vue?vue&type=script&lang=js&"
import style0 from "./modalAddRoom.vue?vue&type=style&index=0&id=610bd146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bd146",
  null
  
)

export default component.exports